import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSurveillanceCctv1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "surveillance-cctv-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,14v3.333A2.848,2.848,0,0,1,5.25,20H.75"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 17.75,
			x2: .75,
			y2: 21.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15,11H1.5a.75.75,0,0,1-.75-.75V6.5A4.5,4.5,0,0,1,5.25,2h16.5a1.5,1.5,0,0,1,1.5,1.5V4.775a1.5,1.5,0,0,1-.891,1.371L16.5,8.751V9.5A1.5,1.5,0,0,1,15,11Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.25,7.084V12.5a1.5,1.5,0,0,1-1.5,1.5H5.25a3,3,0,0,1-3-3h0"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 23.25,
			y1: 8.75,
			x2: 23.25,
			y2: 11.75
		})
	]
});
export default SvgSurveillanceCctv1;
